import React from 'react';

import { Dialog, DialogTitle, DialogContent, useMediaQuery, useTheme, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

import { RemoveButton } from './RemoveButton';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  fullScreenMobile?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
  fullScreenMobile = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const fullScreen = fullScreenMobile && isMobile;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen={fullScreen}
      TransitionComponent={fullScreenMobile ? Transition : undefined}
      maxWidth="sm"
      fullWidth
    >
      {title && (
        <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
          {title}
          <RemoveButton
            onRemove={onClose}
            ariaLabel="Close dialog"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          />
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
